/* eslint-disable no-param-reassign */
/**
 * 这个组件主要是统一消息的显示方式，并避免重复显示
 */
import { Message } from 'element-ui'

let messageInstance = null
let messageTimerId = null

const AMessage = (options) => {
  options = options || {}
  options.type = options.type || 'info'
  if (options.type === 'error') { // 出错提示统一显示5秒
    options.duration = 5000
  }
  if (messageTimerId !== null) {
    window.clearTimeout(messageTimerId)
  }
  messageTimerId = window.setTimeout(() => {
    if (messageInstance !== null) {
      messageInstance.close()
    }
    messageInstance = Message(options)
  }, 50)
};

['success', 'warning', 'info', 'error'].forEach((type) => {
  AMessage[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    if (options.type === 'error') { // 出错提示统一显示5秒
      options.duration = 5000
    }
    if (messageTimerId !== null) {
      window.clearTimeout(messageTimerId)
    }
    messageTimerId = window.setTimeout(() => {
      if (messageInstance !== null) {
        messageInstance.close()
      }
      messageInstance = Message(options)
    }, 50)
  }
})

export default AMessage
